// src/components/SupplierForm.js
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './SupplierForm.css';

// Gerekiyorsa bir kez uygulama girişinde çalıştırın:
// Modal.setAppElement('#root');

const API_BASE = 'https://apiportal.mbsays.com/public/api';

const SupplierForm = () => {
  const token = sessionStorage.getItem('authToken');
  const me = JSON.parse(sessionStorage.getItem('user') || '{}');
  
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`
  };

  /* ---------- STATE ---------- */
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);
  const [search, setSearch]       = useState('');
  const [modalIsOpen, setModalIsOpen]       = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [form, setForm] = useState({
  invoice_number: '',
  creation_date: new Date().toISOString().split('T')[0],
  invoice_date: '',           // Fatura tarihi
  company_name: '',
  total_amount: '',
  due_days: 30,               // varsayılan 30 gün
  account_info: '',
  note: '',
  payment_status: 'Bekliyor'
});
  const [submitting, setSubmitting] = useState(false);

  /* ---------- DATA FETCH ---------- */
  useEffect(() => {
    fetch(`${API_BASE}/supplier-forms`, { headers })
      .then(res => {
        if (!res.ok) throw new Error('Veri yüklenemedi');
        return res.json();
      })
      .then(data => setSuppliers(data))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  /* ---------- HANDLERS ---------- */
  const openModal = supplier => {
  setSelectedSupplier(supplier);
  if (!supplier) {
    // Yeni form
    setForm({
      invoice_number: '',
      creation_date: new Date().toISOString().split('T')[0],
      invoice_date: '',
      company_name: '',
      total_amount: '',
      due_days: 30,
      account_info: '',
      note: '',
      payment_status: 'Bekliyor'
    });
  } else {
    // Düzenleme formu doldurulsun
    setForm({
      invoice_number: supplier.invoice_number || '',
      creation_date: supplier.creation_date || '',
      invoice_date: supplier.invoice_date || '',
      company_name: supplier.company_name || '',
      total_amount: supplier.total_amount || '',
      due_days: supplier.due_days || 30,
      account_info: supplier.account_info || '',
      note: supplier.note || '',
      payment_status: supplier.payment_status || 'Bekliyor'
    });
  }
  setModalIsOpen(true);
};

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedSupplier(null);
  };

  // “Ödendi” olarak işaretle (PUT status)
const markAsPaid = id => {
  const supplier = suppliers.find(s => s.id === id);
  if (!supplier) return;

  const payload = {
    creation_date: supplier.creation_date,
    user_id: supplier.user_id,
    line_number: supplier.line_number,
    invoice_number: supplier.invoice_number,
    invoice_date: supplier.invoice_date,
    company_name: supplier.company_name,
    total_amount: parseFloat(supplier.total_amount),
    due_days: supplier.due_days,
    account_info: supplier.account_info,
    note: supplier.note,
    payment_status: 'paid'
  };

  fetch(`${API_BASE}/supplier-forms/${id}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload)
  })
    .then(res => {
      if (!res.ok) throw new Error('Güncelleme başarısız');
      return res.json();
    })
    .then(() => {
      setSuppliers(prev =>
        prev.map(s =>
          s.id === id ? { ...s, payment_status: 'paid' } : s
        )
      );
      alert("✅ Ödeme durumu güncellendi!");
    })
    .catch(err => alert('❌ Güncelleme hatası: ' + err.message));
};

  // Yeni tedarikçi formu oluştur
 const handleSubmit = e => {
  e.preventDefault();
  setSubmitting(true);

  const payload = {
  creation_date: form.creation_date,
  user_id: me.id,
  line_number: form.invoice_number, // ✅ Laravel backend line_number istiyor olabilir
  invoice_number: form.invoice_number,
  invoice_date: form.invoice_date,
  due_days: form.due_days,
  company_name: form.company_name,
  total_amount: parseFloat(form.total_amount),
  payment_status: form.payment_status,
  account_info: form.account_info,
  note: form.note
};

  const isEdit = selectedSupplier !== null;
  const url = isEdit
    ? `${API_BASE}/supplier-forms/${selectedSupplier.id}`
    : `${API_BASE}/supplier-forms`;

  const method = isEdit ? 'PUT' : 'POST';

  fetch(url, {
    method,
    headers,
    body: JSON.stringify(payload)
  })
    .then(res => {
      if (!res.ok) throw new Error(isEdit ? 'Güncelleme hatası' : 'Kaydetme hatası');
      return res.json();
    })
    .then(response => {
      const updatedItem = response.form ?? response;
      if (isEdit) {
        setSuppliers(prev =>
          prev.map(s =>
            s.id === selectedSupplier.id ? updatedItem : s
          )
        );
        alert('✅ Güncelleme başarılı!');
      } else {
        setSuppliers(prev => [updatedItem, ...prev]);
        alert('✅ Tedarikçi formu başarıyla kaydedildi!');
      }
      // Form reset
      setForm({
        invoice_number: '',
        creation_date: new Date().toISOString().split('T')[0],
        invoice_date: '',
        company_name: '',
        total_amount: '',
        due_days: 30,
        account_info: '',
        note: '',
        payment_status: 'Bekliyor'
      });
      closeModal();
    })
    .catch(err => alert('❌ HATA:\n' + err.message))
    .finally(() => setSubmitting(false));
};
  if (loading) return <div>Yükleniyor…</div>;
  if (error)   return <div>Hata: {error}</div>;

  // Basit arama
  const filtered = suppliers.filter(s =>
    `${s.invoice_number} ${s.company_name}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );
const statusLabel = status => {
  if (status === 'paid' || status === 'Ödendi') return 'Ödendi';
  return 'Bekliyor';
};

const deleteSupplier = id => {
  if (!window.confirm("Bu formu silmek istediğine emin misin?")) return;

  fetch(`${API_BASE}/supplier-forms/${id}`, {
    method: 'DELETE',
    headers
  })
    .then(res => {
      if (!res.ok) throw new Error("Silme başarısız");
      setSuppliers(prev => prev.filter(s => s.id !== id));
      alert("🗑️ Form başarıyla silindi.");
    })
    .catch(err => alert("❌ Silme hatası: " + err.message));
};




  return (
    <div className="supplier-form-container">
      {/* Arama */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Ara..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {/* Tablo */}
      <table className="supplier-table">
        <thead>
          <tr>
            <th>Oluşturma</th>
            <th>Satır No</th>
            <th>Fatura No</th>
            <th>Şirket</th>
            <th>Toplam</th>
            <th>Durum</th>
            <th>Detay</th>
          </tr>
        </thead>
        <tbody>
  {filtered.map(s => (
    <tr key={s.id}>
      <td>{s.creation_date}</td>
      <td>{s.line_number}</td>
      <td>{s.invoice_number}</td>
      <td>{s.company_name}</td>
      <td>{s.total_amount}</td>
      <td>
        {s.payment_status === 'pending' || s.payment_status === 'Bekliyor' ? (
          <button
            className="mark-paid-button"
            onClick={() => markAsPaid(s.id)}
          >
            Ödendi Olarak İşaretle
          </button>
        ) : (
          'Ödendi'
        )}
      </td>
        <td>
  <button className="detail-button" onClick={() => openModal(s)}>Düzenle</button>
  <button className="delete-button" onClick={() => deleteSupplier(s.id)} >Sil</button>
</td>


    </tr>
  ))}
</tbody>
      </table>
      <button className="add-button" onClick={() => openModal(null)}>
        Yeni Tedarikçi Formu
      </button>

<Modal
  isOpen={modalIsOpen}
  onRequestClose={closeModal}
  contentLabel="Tedarikçi Formu"
  className="modal"
  overlayClassName="modal-overlay"
>
  <form onSubmit={handleSubmit}>
    <h2>{selectedSupplier ? "Tedarikçi Formunu Güncelle" : "Yeni Tedarikçi Formu"}</h2>
    <div className="modal-body">
      <div className="form-group">
        <label>Fatura No</label>
        <input
          type="text"
          value={form.invoice_number}
          onChange={e => setForm(f => ({ ...f, invoice_number: e.target.value }))}
          required
        />
      </div>
      <div className="form-group">
        <label>Oluşturma Tarihi</label>
        <input
          type="date"
          value={form.creation_date}
          onChange={e => setForm(f => ({ ...f, creation_date: e.target.value }))}
          required
        />
      </div>
      <div className="form-group">
        <label>Şirket İsmi</label>
        <input
          type="text"
          value={form.company_name}
          onChange={e => setForm(f => ({ ...f, company_name: e.target.value }))}
          required
        />
      </div>
      <div className="form-group">
        <label>Toplam Tutar</label>
        <input
          type="number"
          value={form.total_amount}
          onChange={e => setForm(f => ({ ...f, total_amount: e.target.value }))}
          required
        />
      </div>
      <div className="form-group">
        <label>Ödeme Durumu</label>
        <select
          value={form.payment_status}
          onChange={e => setForm(f => ({ ...f, payment_status: e.target.value }))}
          required
        >
          <option value="pending">Bekliyor</option>
          <option value="paid">Ödendi</option>
        </select>
      </div>
      <div className="form-group">
        <label>Fatura Tarihi</label>
        <input
          type="date"
          value={form.invoice_date}
          onChange={e => setForm(f => ({ ...f, invoice_date: e.target.value }))}
        />
      </div>
      <div className="form-group">
        <label>Ödeme Vadesi (Gün)</label>
        <select
          value={form.due_days}
          onChange={e => setForm(f => ({ ...f, due_days: parseInt(e.target.value) }))}
        >
          {[30, 60, 90, 120, 150].map(gun => (
            <option key={gun} value={gun}>{gun} gün</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label>Hesap Bilgileri</label>
        <textarea
          value={form.account_info}
          onChange={e => setForm(f => ({ ...f, account_info: e.target.value }))}
        />
      </div>
      <div className="form-group">
        <label>Not</label>
        <textarea
          value={form.note}
          onChange={e => setForm(f => ({ ...f, note: e.target.value }))}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <button type="submit" className="submit-button" disabled={submitting}>
          {submitting ? 'Kaydediliyor…' : (selectedSupplier ? 'Güncelle' : 'Kaydet')}
        </button>
        <button type="button" className="modal-close" onClick={closeModal}>x</button>
      </div>
    </div>
  </form>
</Modal>

    </div>
  );
};

export default SupplierForm;
